import styled from 'styled-components';
import theme from 'shared/themes/default';

interface HorizontalRuleProps {
  color?: string;
  paddingTop?: string;
}

const HorizontalRuleStyled = styled.hr.withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) =>
    prop !== 'color' && defaultValidatorFn(prop),
})<HorizontalRuleProps>`
  border: 1px solid ${(props) => props.color};
  border-width: 0 0 1px;
  width: 100%;
  display: inline-block;
  padding-top: ${(props) => props.paddingTop};
`;

const HorizontalRule = ({
  color = theme.palette.disabledDark,
  ...props
}: HorizontalRuleProps) => <HorizontalRuleStyled color={color} {...props} />;

export default HorizontalRule;
export type { HorizontalRuleProps };
